import test from './components/test';
import fab from './components/fab';

document.addEventListener(
  'DOMContentLoaded',
  () => {
    test();
    fab();
  },
  false,
);
